export default __webpack_public_path__ + "static/treatmentareas_lipsafter-d36fbb885368d1dd6fecb763a8a82cec.webp";